// extracted by mini-css-extract-plugin
export default {"wrapper":"Dk8hn","closer":"LuDgp","content":"UdTbC","body":"OfAT-","header":"_8-Rtd","webview":"FU6gY","hidden":"HB61q","skeleton-progress":"sjXVd"};